<template lang="html">

  <section class="footer">
    <div class="d-flex row-center aic">
     
      <section class="row-center flex-wrap">
        <div class="link-footer">
          <router-link to="/politica-de-privacidad">Política de privacidad</router-link>
          <span>·</span>
        </div>
        <div class="link-footer">
          <router-link to="/politica-de-cookies">Política de Cookies</router-link>
          <span>·</span>
        </div>
        <div class="link-footer">
          <router-link to="/aviso-legal">Aviso legal</router-link>
          <span>·</span>
        </div>
        <div class="link-footer">
          <router-link to="/faqs">FAQs</router-link>
        </div>
      </section>
    </div>
  </section>

</template>

<script lang="js">



export default {
  name: 'app-footer',
  props: [],
  mounted() {

  },
  data() {
    return {

    }
  },
  methods: {

  },
  components: {

  }
}
</script>

<style lang="scss">
.footer {
  background: black;
  color: white;
  padding: 20px 8vw;

  @media screen and(max-width:600px) {
    font-size: 14px;
    padding: 20px;
  }

  .link-footer {
    @media screen and(max-width:600px) {
      min-width: 50%;
      text-align: left;
      margin-bottom: 5px;
      span {
        display: none;
      }
    }
    
  }

  .subpage {
    font-size: 18px;
    color: white;
    background-image: url(/static/img/flecha-white.svg);
    background-size: 20px;
    background-position: right center;
    background-repeat: no-repeat;
    padding-right: 25px;

    @media screen and(max-width:900px) {
      margin-bottom: 10px;
      display: inline-block;
    }

    strong {
      font-family: "Futura Md BT Bold";
    }
  }

  span {
    margin: 0 10px;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/parts/footer.vue